
import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";

const CONF = window?.confPub;
const CONTRIBUTIONS_ROUTES = CONF?.ROUTES?.CONTRIBUTIONS

export const getContributions = async (params) => {
    try {

        const urlParams = params ? `?${params}` : ''

        const resp = await axiosCoralie.get(CONTRIBUTIONS_ROUTES?.GET_CONTRIBUTIONS + urlParams)

        const contributions = resp?.data?.rows
        const nombreContributions = resp?.data?.nombreContributions

        if (contributions?.length > 0) {

            return { contributions, nombreContributions }
        }else {

            throw new Error("Aucune contribution trouvée")
        }

    } catch (err) {
        throw err;
    }
}

export const getContributionById = async (id) => {
    try {

        const urlWithId = replaceUrlPlaceholders(CONTRIBUTIONS_ROUTES?.GET_CONTRIBUTION_BY_ID, { id: id })
        const resp = await axiosCoralie.get(urlWithId)
        const contribution = resp?.data?.contribution

        if (contribution) {

            return contribution
        }else {

            throw new Error("Aucune contribution trouvée pour cet id")
        }

    } catch (err) {
        throw err;
    }
}

export const addContributionToServer = async (dataToSend) => {
    try {

        const resp = await axiosCoralie.post(CONTRIBUTIONS_ROUTES?.ADD_CONTRIBUTION, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const updateContribution = async (id, dataToSend) => {
    try {

        const urlWithId = replaceUrlPlaceholders(CONTRIBUTIONS_ROUTES?.UPDATE_CONTRIBUTION, { id: id })
        const resp = await axiosCoralie.put(urlWithId, dataToSend)
        return resp?.data

    } catch (err) {

        throw err;
    }
}


export const deleteContribution = async (id) => {
    try {

        const urlWithId = replaceUrlPlaceholders(CONTRIBUTIONS_ROUTES?.DELETE_CONTRIBUTION, { id: id })
        const resp = await axiosCoralie.delete(urlWithId)
        return resp?.data

    } catch (err) {

        throw err;
    }
}

export const getSousCategoriesRef = async () => {

    try {
        const resp = await axiosCoralie.get(CONTRIBUTIONS_ROUTES?.GET_SOUS_CATEGORIES_REF)

        const sousCategoriesRef = resp?.data?.sousCategoriesRef

        if (sousCategoriesRef?.length > 0) {

            return { sousCategoriesRef }
        }else {

            throw new Error("Aucune contribution trouvée")
        }

    } catch (err) {
        throw err;
    }
}